import * as process from 'process';

export const firebaseConfig = {
  options: {
    apiKey: process.env.FCM_CONFIG_API_KEY,
    authDomain: process.env.FCM_CONFIG_AUTH_DOMAIN,
    databaseURL: process.env.FCM_CONFIG_DATABASE_URL,
    projectId: process.env.FCM_CONFIG_PROJECT_ID,
    storageBucket: process.env.FCM_CONFIG_STORAGE_BUCKET,
    messagingSenderId: process.env.FCM_CONFIG_MESSAGING_SENDER_ID,
    appId: process.env.FCM_CONFIG_APP_ID,
    measurementId: process.env.FCM_CONFIG_MEASUREMENT_ID,
  },
  vapid: process.env.FCM_VAPID_KEY,
};
